import { render, staticRenderFns } from "./TodoDetail.vue?vue&type=template&id=6f3c9a78&scoped=true"
import script from "./TodoDetail.vue?vue&type=script&lang=js"
export * from "./TodoDetail.vue?vue&type=script&lang=js"
import style0 from "./TodoDetail.vue?vue&type=style&index=0&id=6f3c9a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3c9a78",
  null
  
)

export default component.exports